__webpack_require__.p = "/settings/";